import { getAutomotiveSubscriptionStatusFromLifecycleState } from '@sxm-de/dev-kits/web-sdk/domains/subscriptions-core';
import {
    AutomotiveSubscriptionStatus,
    DomainInitPayload,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getDeviceByRadioId } from '@sxm-de/dev-kits/web-sdk/domains/devices';
import { normalizeRadioIdForServiceCallWithSupportForUUID } from '@sxm-de/dev-kits/web-sdk/utils';

interface GetAutomotiveSubscriptionStatusByRadioIdFnPayload {
    radioId: string;
}

export type GetAutomotiveSubscriptionStatusByRadioIdFn = (
    payload: GetAutomotiveSubscriptionStatusByRadioIdFnPayload,
) => Promise<AutomotiveSubscriptionStatus>;

export function initGetAutomotiveSubscriptionStatusByRadioId({
    dependencies,
}: DomainInitPayload): GetAutomotiveSubscriptionStatusByRadioIdFn {
    return async ({
        radioId,
    }: GetAutomotiveSubscriptionStatusByRadioIdFnPayload) => {
        const { appEventSdk } = dependencies;
        let status;

        try {
            status = await getDeviceByRadioId(
                {
                    radioId:
                        normalizeRadioIdForServiceCallWithSupportForUUID(
                            radioId,
                        ),
                },
                dependencies,
            );

            appEventSdk.trackEvent({
                event: 'device-info',
                deviceInfo: {
                    vid: radioId,
                    year: status.vehicleState?.year,
                    make: status.vehicleState?.make,
                    model: status.vehicleState?.model,
                },
            });
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }

        return getAutomotiveSubscriptionStatusFromLifecycleState(
            status.lifecycleState,
        );
    };
}
